import { useEffect, useRef, useState } from 'react';
import { ClickToCallEnergy, IClickToCallCallEnergy, VfModal } from '@vfit/shared/components';
import { AppMobile, checkWindow } from '@vfit/shared/data-access';
import { IActionSlide } from '@vfit/shared/models';
import { ContainerEnergy } from './clickToCallEnergyWrapper.style';
import { IProduct } from '@vfit/consumer/data-access';
import { removeCurrency } from '@vfit/consumer/hooks';
import {
  CloseBtnHandle,
  VolaHandle,
} from 'libs/shared/components/src/lib/ModalWrappers/interfaces';

const ClickToCallEnergyWrapper = () => {
  const initialConfig: IClickToCallCallEnergy = {
    url: '',
    entryPoint: '',
  };

  const setModalHeight = () => {
    const defaultValue = 563;
    if (!checkWindow()) return defaultValue;
    const height = window?.innerHeight;
    if (!height) return defaultValue;
    return height - (height * 30) / 100;
  };

  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalFirstOpen, setModalFirstOpen] = useState<boolean>(true);
  const [modalDetail, setModalDetail] = useState<IClickToCallCallEnergy>(initialConfig);

  const childRef = useRef<VolaHandle | null>(null);
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Tab') {
      e.preventDefault();
      if (childRef.current) {
        childRef?.current.focusInput();
      }
      // const currentFocusElement = document.activeElement;
    }
  };

  const modalCloseBtnRef = useRef<CloseBtnHandle | null>(null);
  useEffect(() => {
    function tabKeyDownHandler(e: globalThis.KeyboardEvent) {
      if (showModal && e.key === 'Tab') {
        e.preventDefault();
        if (modalCloseBtnRef.current) {
          modalFirstOpen && modalCloseBtnRef?.current?.focusCloseBtn();
          setModalFirstOpen(false);
        }
      }
    }
    document.addEventListener('keydown', tabKeyDownHandler);
    return () => {
      document.removeEventListener('keydown', tabKeyDownHandler);
    };
  }, [showModal, modalCloseBtnRef.current]);

  const actionEnergyCtc = (event) => {
    const { detail } = event as CustomEvent as {
      detail: {
        product: IProduct;
        action: IActionSlide;
      };
    };
    setModalDetail({
      url: detail?.action?.url || '',
      entryPoint: detail?.action?.localUrl || '',
      pageProduct: {
        product_id: detail?.product?.offerId?.toString() || '',
        product_name: detail?.product?.title || '',
        product_price: removeCurrency(detail?.product?.price || ''),
        product_quantity: '1',
        product_category: detail?.product?.category || 'fixed',
      },
    });
    setShowModal(true);
  };

  const resetModalStatus = () => {
    setModalDetail(initialConfig);
    setShowModal(false);
    setModalFirstOpen(true);
  };

  const handleCloseModal = () => {
    resetModalStatus();
  };

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('energyCtcNotificationEvent', actionEnergyCtc);
    }
    return () => document.removeEventListener('energyCtcNotificationEvent', actionEnergyCtc);
  }, []);

  return (
    <div onKeyDown={handleKeyDown}>
      <VfModal
        wrapperId={'ctc-energy'}
        height={setModalHeight()}
        isOpen={showModal}
        handleClose={handleCloseModal}
        isModalFullContainer={AppMobile.checkIsApp()}
        ref={modalCloseBtnRef}
      >
        <ContainerEnergy isApp={AppMobile.checkIsApp()}>
          <ClickToCallEnergy
            childRef={childRef}
            modalCloseBtnRef={modalCloseBtnRef}
            url={modalDetail.url}
            entryPoint={modalDetail.entryPoint}
            taggingOpts={modalDetail?.taggingOpts}
            pageProduct={modalDetail?.pageProduct}
          />
        </ContainerEnergy>
      </VfModal>
    </div>
  );
};

export default ClickToCallEnergyWrapper;

